import React, { useCallback, createElement, memo } from 'react';

import isEqual from 'lodash/isEqual';

import { getWidgetByName } from 'scenes/HomeDashboard/widgets';

import AnchorWidget from './AnchorWidget';

const Widget = ({
  id,
  preset,
  isNew,
  parentPreset,
  globalPeriod,
  onDelete,
  onEdit,
  onCollapse,
  collapsed,
  editable,
  tooltipPosStrategy,
  affix,
  active,
}) => {
  const handleClose = useCallback(() => onDelete(id), [id]);

  const handleSave = useCallback(
    data =>
      onEdit({
        ...preset,
        data,
      }),
    [preset]
  );

  return (
    <AnchorWidget id={id} isNew={isNew} collapsed={collapsed}>
      {createElement(getWidgetByName(preset.screen), {
        active: active,
        id: id,
        key: id,
        initialState: preset.data,
        parentState: parentPreset,
        subTitle: preset.title,
        globalPeriod: globalPeriod,
        collapsed: collapsed,
        editable: editable,
        tooltipPosStrategy: tooltipPosStrategy,
        affix: affix,
        onClose: handleClose,
        onSave: handleSave,
        onCollapse: onCollapse,
      })}
    </AnchorWidget>
  );
};

export default memo(
  Widget,
  (
    {
      /* eslint-disable */ affix: affixPrev,
      onDelete: onDeletePrev,
      onEdit: onEditPrev,
      onCollapse: onCollapsePrev,
      ...prev
    },
    {
      affix: affixNext,
      onDelete: onDeleteNext,
      onEdit: onEditNext,
      onCollapse: onCollapseNext,
      ...next
    }
  ) =>
    /* eslint-disable */
    isEqual(prev, next)
);
